// MobileDeckCard — Kachel des mobilen Kartenrasters: Kartenbild mit ×N-Badge,
// Auswahl-Häkchen, Highlight-Ring und Label-Punkten unter dem Bild.
import React, { useCallback } from 'react';
import { Check } from 'lucide-react';
import CardImage from '../../../../ui/CardImage';
import CardOverlays from '../../../../ui/CardOverlays';
import { useLongPress } from '../../../../hooks/useLongPress';
import LabelIndicators from '../../components/LabelIndicators';

export default function MobileDeckCard({
  card,
  labels = [],
  selected = false,
  selectionMode = false,
  highlighted = false,
  onTap,
  onLongPress,
}) {
  const cardId = card.scryfallId || card.id;
  const quantity = Number(card.quantity) > 0 ? Number(card.quantity) : 1;

  const handleLongPress = useCallback(() => onLongPress?.(card), [onLongPress, card]);
  // Die Geste liegt auf der ganzen Kachel, nicht auf dem Klick-Ziel: der Druck kann auf
  // dem Kartenbild beginnen, dessen pointer-events abgeschaltet sind. onClickCapture des
  // Hooks unterdrückt den Klick, den der Browser nach einem ausgelösten Long-Press
  // zusätzlich feuert.
  const longPressHandlers = useLongPress(handleLongPress);

  const classes = ['mobile-deck-card'];
  if (selected) classes.push('mobile-deck-card--selected');
  if (onTap) classes.push('mobile-deck-card--tappable');

  return (
    <div
      className={classes.join(' ')}
      data-card-id={cardId}
      {...(onLongPress ? longPressHandlers : {})}
    >
      {/* Klick-Ziel als Geschwister statt als umschließender Button: auf dem
          Kartenbild liegen eigene Bedienelemente (Flip-Knopf, Overlays). */}
      {onTap && (
        <button
          type="button"
          className="mobile-deck-card__hit"
          aria-label={card.name}
          aria-pressed={selectionMode ? selected : undefined}
          onClick={() => onTap(card)}
        />
      )}
      <CardImage src={card.imageUrl} backSrc={card.imageUrlBack} alt={card.name}>
        <CardOverlays>
          {quantity > 1 && (
            <CardOverlays.Corner position="top-left">
              <CardOverlays.Badge passive>×{quantity}</CardOverlays.Badge>
            </CardOverlays.Corner>
          )}
          {selected && (
            <CardOverlays.Corner position="top-right">
              <CardOverlays.Badge passive>
                <Check size={12} aria-hidden />
              </CardOverlays.Badge>
            </CardOverlays.Corner>
          )}
          <CardOverlays.HighlightRing active={highlighted} />
        </CardOverlays>
      </CardImage>
      {labels.length > 0 && (
        <div className="mobile-deck-card__labels">
          <LabelIndicators labels={labels} variant="dots" />
        </div>
      )}
    </div>
  );
}
